import React, { Component } from "react";
import {
    Button,
} from "reactstrap";
import InputMask from 'react-input-mask';
import Registry from "../../Utils/Registry";
import {NotificationManager} from "react-notifications";

class ConfigurationFormPhone extends Component {
    constructor(props) {
        super(props);

        this.state = {
            phone_number: ""
        };

        this.api = Registry.registered("api");
        this.inputChanged = this.inputChanged.bind(this);
    }

    componentDidMount(){
        let user = Registry.observe(this, "user", user => {
            this.setState({phone_number: user.phone_number.replace("+33", "0")});
        });
        if(user)
            this.setState({phone_number: user.phone_number.replace("+33", "0")});
    }

    inputChanged(e, input_key){
        if(this.state.hasOwnProperty(input_key) && typeof e !== "undefined"){
            let nState = this.state;

            nState[input_key] = (typeof e === "string" ? e : e.target.value);
            this.setState(nState);
        }
    }

    sendPhoneNumber = () => {
        if (this.state.phone_number === "") {
            NotificationManager.error("Veuillez renseigner votre téléphone");
        } else {
            this.api.put("/business/" + this.props.business.id + "/callback_request", {phone_number: this.state.phone_number})
                .then(res => {
                    this.props.toggle();
                    this.props.loadBusiness();
                    NotificationManager.success("Demande envoyée");
                })
                .catch(err => {
                    NotificationManager.error("Une erreur est survenue");
                });
        }
    };

    render() {
        return (
            <div>
                <div className="ty-block configuration-form text-center pad-20">
                    Vous allez &ecirc;tre recontact&eacute;<br/>
                    par un conseiller Tankyou au numéro suivant:<br/>
                    <div className="d-flex justify-content-center marg-t-15">
                        <div className="col-md-5">
                            <InputMask
                                className="form-control pad-10"
                                mask="99 99 99 99 99"
                                maskChar=" "
                                value={this.state.phone_number}
                                onChange={(e) => {this.inputChanged(e, "phone_number")} }
                            />
                        </div>
                    </div>
                </div>
                <div className="center pad-b-20 pad-t-20">
                    <Button className="text-uppercase" size="" color="primary" onClick={this.sendPhoneNumber}>Rappelez-moi</Button>
                </div>
            </div>
        );
    };
}

ConfigurationFormPhone.defaultProps = {
    user: null,
    toggle: () => {},
    loadBusiness: () => {}
};

export default ConfigurationFormPhone;



// WEBPACK FOOTER //
// ./src/components/Account/ConfigurationFormPhone.js